import { TaxJurisdiction } from '../../pages/orders/interfaces/tax-jurisdiction.interface';
import { createReducer, on } from '@ngrx/store';
import * as TaxJurisdictionsActions from './tax-jurisdictions.actions';

export interface TaxJurisdictionsState {
  response: TaxJurisdiction[] | null;
  error: any | null;
  errorByKey?: { [key: string]: any };
  loading: { [key: string]: boolean };
  cache?: { [key: string]: TaxJurisdiction[] };
}

export const initialState: TaxJurisdictionsState = {
  response: null,
  error: null,
  errorByKey: {},
  loading: {},
  cache: {},
};

function getJurisdictionKey(params: any): string {
  return [params.city, params.postalCode, params.countryCode, params.stateCode, params.district, params.isOtc]
    .map((v) => v ?? '')
    .join('|');
}

export const taxJurisdictionsReducer = createReducer(
  initialState,
  on(TaxJurisdictionsActions.checkTaxJurisdiction, (state, { params }) => {
    const key = getJurisdictionKey(params);
    return {
      ...state,
      loading: { ...state.loading, [key]: true },
      errorByKey: { ...(state.errorByKey || {}), [key]: null },
      error: null,
    };
  }),
  on(TaxJurisdictionsActions.checkTaxJurisdictionRequestByKey, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    errorByKey: { ...(state.errorByKey || {}), [key]: null },
    error: null,
  })),
  on(TaxJurisdictionsActions.checkTaxJurisdictionSuccess, (state, { response }) => ({
    ...state,
    response,
    error: null,
  })),
  on(TaxJurisdictionsActions.checkTaxJurisdictionFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(TaxJurisdictionsActions.checkTaxJurisdictionSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    response,
    cache: { ...(state.cache || {}), [key]: response },
    errorByKey: { ...(state.errorByKey || {}), [key]: null },
    error: null,
  })),
  on(TaxJurisdictionsActions.checkTaxJurisdictionFailureByKey, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    errorByKey: { ...(state.errorByKey || {}), [key]: error },
    error,
  })),
  on(TaxJurisdictionsActions.setEmptyCache, (state, { key, response }) => {
    return {
      ...state,
      cache: { ...(state.cache || {}), [key]: response },
      loading: { ...state.loading, [key]: true },
      errorByKey: { ...(state.errorByKey || {}), [key]: null },
      error: null,
    };
  }),
);
